export const parseSQLToolData = (tool) => {
    var _a;
    const args = (() => {
        var _a;
        if (!((_a = tool.function) === null || _a === void 0 ? void 0 : _a.arguments)) {
            return {};
        }
        try {
            return JSON.parse(tool.function.arguments);
        }
        catch (_b) {
            return {};
        }
    })();
    if (!((_a = tool.result) === null || _a === void 0 ? void 0 : _a.content)) {
        return {
            resultData: null,
            parseError: false,
            args,
        };
    }
    try {
        const parsed = JSON.parse(tool.result.content);
        if (parsed &&
            typeof parsed === 'object' &&
            'content' in parsed &&
            typeof parsed.content === 'string' &&
            (('tool_call_id' in parsed && typeof parsed.tool_call_id === 'string') ||
                ('tool_name' in parsed && typeof parsed.tool_name === 'string'))) {
            return {
                resultData: JSON.parse(parsed.content),
                parseError: false,
                args,
            };
        }
        return {
            resultData: parsed,
            parseError: false,
            args,
        };
    }
    catch (_b) {
        return {
            resultData: null,
            parseError: true,
            args,
        };
    }
};
